export default "__VITE_ASSET__DWp3UR9f__"